import { SelectAttributesAndBundles } from './SelectAttributesAndBundles';
import { ContainerInputProps } from '../../../common/components/input-props';
import { LookupsFetcher } from '../common';
import { useDataStore } from '@/app/core/components/step-wizard';
import { useEffect, useState } from 'react';
import { attributesAndBundlesInfoValidator } from '@ssar-app/domain';

export const BundlesAndAttributesContainer = (props: ContainerInputProps) => {
  const [subCode, setSubCode] = useState<string>('');
  const { keys } = props;
  const { data } = useDataStore();
  useEffect(() => {
    if (data?.subCode !== '') {
      setSubCode(data?.subCode);
    }
  }, [data?.subCode]);
  return (
    <>
      {subCode !== '' && (
        <LookupsFetcher
          subCode={subCode}
          onSuccess={(lookupsManager, isLoading) => {
            return (
              <SelectAttributesAndBundles
                stepKey={keys}
                moduleProps={{
                  lookupsManager: lookupsManager,
                  isLoading: isLoading,
                  additionalKey: ['reports'],
                }}
                validator={attributesAndBundlesInfoValidator}
              />
            );
          }}
          onError={(error) => {
            console.error(error);
          }}
        />
      )}
    </>
  );
};
